import JBL from "../assets/images (2).jpeg"
export default JBL